const NUM_SYMBOLS = ['', 'k', 'M', 'B', 'T'];

export const formatDigits = (num: number, fractions = 2) => {
  if (num < 0 && num >= -0.1) {
    return 0;
  }
  return num?.toLocaleString(undefined, { maximumFractionDigits: fractions });
};

export function formatNumDecimals(number: number) {
  // If number is null or  undefined, return an empty string.
  if (!number) {
    return 0;
  }
  // If the number is large or zero, return it without decimals
  if (Math.abs(number) >= 1000 || Math.abs(number) === 0) {
    return Math.round(number).toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  // If the number is very small, return it with at least 3 significant digits
  if (Math.abs(number) < 1) {
    return number.toPrecision(3);
  }

  // Otherwise, return the number with all decimal places
  return number.toLocaleString(undefined, { maximumFractionDigits: 2 }); // This will preserve all decimal places
}

export const formatNum = (num?: number, fractions?: number) => {
  if (!num) return '0';
  const tier = (Math.log10(Math.abs(num)) / 3) | 0;

  // if zero, we don't need a suffix
  if (tier == 0) return formatDigits(num, fractions);

  // get suffix and determine scale
  const suffix = NUM_SYMBOLS[tier];
  const scale = Math.pow(10, tier * 3);

  // scale the number
  const scaled = num / scale;

  // format number and add suffix
  return formatDigits(scaled, fractions) + (suffix ?? '');
};

export const isNullish = (value: number | undefined | null) =>
  value === undefined || value === null || isNaN(value);

export const per = (num: number, total: number) => (num * total) / 100;

export const formatNumber = (value: number) =>
  value.toLocaleString(navigator.language, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const checkAndFormatNumber = (num: number | string) => {
  if (typeof num === 'string') {
    num = Number(num);
  }

  if (isNaN(num)) {
    return 0;
  }

  return formatNumber(num);
};
